import '../../index.scss';

const Services = () => {
    return (
        <section id="two" className="wrapper style3 fade-up">
            <div className="inner">
                <h2>Nossos serviços</h2>
                <p>Temos uma gama de serviços disponíveis para você e sua empresa evoluirem.</p>
                <div className="features">
                    <section>
                        <span className="icon solid major fa-code"></span>
                        <h3>Criação de Landing Page</h3>
                        <p>Crie sua Landing Page com base em um template ou faça um formato personalizado. Consulte Valores!</p>
                    </section>
                    <section>
                        <span className="icon solid major fa-link"></span>
                        <h3>Criação de Dashboards personalizados</h3>
                        <p>Integramos com sua API ou API de terceiros e geramos o seu dashboard.</p>
                    </section>
                    <section>
                        <span className="icon solid major fa-rss"></span>
                        <h3>Blogs</h3>
                        <p>Cansado daqueles blogs genéricos? Temos diversos templates com a sua cara!</p>
                    </section>
                    <section>
                        <span className="icon solid major fa-desktop"></span>
                        <h3>E-Commerce</h3>
                        <p>Tem um produto ou serviço e gostaria de apresentá-lo para o mundo? Nós podemos te ajudar com isso.</p>
                    </section>
                    <section>
                        <span className="icon solid major fa-gem"></span>
                        <h3>Hospedagem e Dominio</h3>
                        <p>Deixe que nós tomamos conta do seu dominio e da hospedagem completa da sua aplicação.</p>
                    </section>
                    <section>
                        <span className="icon solid major fa-lock"></span>
                        <h3>Segurança e monitoramento</h3>
                        <p>Garantimos uptime de 99.9% em todos os serviços, monitoramos seus serviços com segurança.</p>
                    </section>
                </div>
                <ul className="actions">
                    <li><a href="#GetInTouch" className="button">Entre em contato agora!</a></li>
                </ul>
            </div>
        </section>
    )
}

export default Services;